import { render } from "./GameServerKey.vue?vue&type=template&id=50b8de17"
import script from "./GameServerKey.vue?vue&type=script&lang=ts"
export * from "./GameServerKey.vue?vue&type=script&lang=ts"
script.render = render

export default script